import { useEffect } from 'react';

const IdleTimeout = ({ timeout, onIdle }) => {
  let timeoutId;

  const resetTimer = () => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(onIdle, timeout);
  };

  useEffect(() => {
    resetTimer();

    const clearTimer = () => clearTimeout(timeoutId);

    window.addEventListener('mousemove', resetTimer);
    window.addEventListener('mousedown', resetTimer);
    window.addEventListener('keypress', resetTimer);
    window.addEventListener('touchmove', resetTimer);

    return () => {
      clearTimer();
      window.removeEventListener('mousemove', resetTimer);
      window.removeEventListener('mousedown', resetTimer);
      window.removeEventListener('keypress', resetTimer);
      window.removeEventListener('touchmove', resetTimer);
    };
  }, [timeout, onIdle]);

  return null;
};

export default IdleTimeout;